import moment from 'moment'

import 'moment/locale/es'
import 'moment/locale/it'

import 'moment-timezone'

moment.locale('en')

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
